export function OutlineFilePdfIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21.0004V15.002C3.7774 15.0068 4.55959 15.0116 5.33699 15.0163C6.33993 14.9108 7.18451 15.8417 7.2277 16.9119C7.27569 18.054 6.40711 19.1337 5.33699 19.0281H3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.91016 15.002V21.0004C10.6972 20.9908 11.4793 20.986 12.2663 20.9764C13.682 21.1012 14.8865 19.7863 14.9632 18.1835C15.0448 16.4896 13.8451 14.954 12.3479 15.0163C11.5369 15.0116 10.7259 15.0068 9.91016 15.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6938 21.0004V15.002H21.1489"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6938 18.4004H20.7507"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1813 12.0025V8.83048C19.1813 8.29782 18.9702 7.79395 18.5959 7.41485L14.7665 3.58545C14.3922 3.21115 13.8835 3 13.3509 3H7.11729C6.01358 3 5.11621 3.89737 5.11621 5.00108V11.9977"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M13.1831 3.00391V7.28919C13.1831 8.23454 13.9509 9.00234 14.8963 9.00234H19.1815"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
